import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal } from "./motion";
import Mandala from "./Mandala";
import { waLink, RESPONSE_PROMISE } from "../lib/site";

export default function CTABanner({ title, accent, copy }) {
  return (
    <section className="bg-white px-4 sm:px-6 lg:px-8 py-16 sm:py-20" data-testid="cta-banner">
      <div className="max-w-7xl mx-auto relative overflow-hidden rounded-3xl bg-navy text-white px-6 py-16 sm:px-12 lg:px-20 lg:py-24 grain">
        <Mandala className="absolute -right-28 -top-28 w-[420px] h-[420px] text-steel opacity-60 spin-slow" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(249,115,22,0.12),transparent_55%)]" />
        <Reveal className="relative z-10">
          <p className="font-mono text-[11px] tracking-[0.3em] text-saffron mb-5">ASK SAARTHVA</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-2xl leading-tight">
            {title || "Start with"} <span className="text-saffron">{accent || "one requirement."}</span>
          </h2>
          <p className="mt-4 text-slate-300 max-w-xl text-base sm:text-lg">
            {copy || "One item. One category. One site. Give us something to solve."}
          </p>
          <p className="mt-3 font-mono text-[11px] tracking-[0.15em] text-slate-500">{RESPONSE_PROMISE}</p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link
              to="/request-quote"
              data-testid="cta-request-quote-button"
              className="inline-flex items-center gap-2 rounded-full bg-saffron hover:bg-saffrondark text-white font-semibold px-7 py-3.5 transition-colors"
            >
              Ask Saarthva <ArrowUpRight className="w-4 h-4" />
            </Link>
            <a
              href={waLink("Hi Saarthva, I have a requirement I'd like to discuss.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-whatsapp-button"
              className="inline-flex items-center gap-2 rounded-full border border-white/25 hover:border-white/60 text-white font-semibold px-7 py-3.5 transition-colors"
            >
              <MessageCircle className="w-4 h-4" /> Talk on WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
